export default __webpack_public_path__ + "static/media/testimony3.37cbb02b.png";